import { IEditFormForClientManagerState } from './editFormForClientManagerContext';
import {
	EditFormForClientManagerActionTypes,
	TEditFormForClientManagerAction,
} from './EditFormForClientManagerActions';

export const editFormForClientManagerReducer = (
	state: IEditFormForClientManagerState,
	action: TEditFormForClientManagerAction,
): IEditFormForClientManagerState => {
	switch (action.type) {
		case EditFormForClientManagerActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case EditFormForClientManagerActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditFormForClientManagerActionTypes.SET_ALL_DATA:
			return {
				...state,
				fullRestaurantInfo: action.payload.fullRestaurantInfo,
				useMenuVersion: action.payload.useMenuVersion,
				useContentVersion: action.payload.useContentVersion,
				customerMenuVersion: action.payload.customerMenuVersion,
				customerContentVersion: action.payload.customerContentVersion,
				restaurantMenuVersion: action.payload.restaurantMenuVersion,
				restaurantContentVersion: action.payload.restaurantContentVersion,
			};
		case EditFormForClientManagerActionTypes.TOGGLE_USE_MENU_VERSION:
			return {
				...state,
				useMenuVersion: action.payload.useMenuVersion,
				restaurantMenuVersion: action.payload.restaurantMenuVersion,
			};
		case EditFormForClientManagerActionTypes.TOGGLE_USE_CONTENT_VERSION:
			return {
				...state,
				useContentVersion: action.payload.useContentVersion,
				restaurantContentVersion: action.payload.restaurantContentVersion,
			};
		case EditFormForClientManagerActionTypes.CHANGE_RESTAURANT_MENU_VERSION:
			return {
				...state,
				restaurantMenuVersion: action.payload.restaurantMenuVersion,
			};
		case EditFormForClientManagerActionTypes.CHANGE_RESTAURANT_CONTENT_VERSION:
			return {
				...state,
				restaurantContentVersion: action.payload.restaurantContentVersion,
			};
		case EditFormForClientManagerActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditFormForClientManagerActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditFormForClientManagerActionTypes.RESET_FIELDS:
			return {
				...state,
				fullRestaurantInfo: null,
				useMenuVersion: 'None',
				useContentVersion: 'None',
				customerMenuVersion: '',
				customerContentVersion: '',
				restaurantMenuVersion: '',
				restaurantContentVersion: '',
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
